import gql from "graphql-tag";
const getEntityDB = gql(`
query MyQuery {
EntityDB_allfields {
  ADVFiler
  ADVStatus
  AIFMDReg1
  AIFMDReg2
  AIFMDReg3
  AIFMDReg4
  AddCommit
  AddRegCountry
  AddRegDate
  AddRegNum
  AggCapCommit
  AltTaxID
  Amend1
  AnnRptDueDate
  BalCoEntity
  BalCommit
  BorrowLimit
  CACanDate
  CALPNum
  CARegDate
  CAStatus
  CFTCNoAction
  CIKNum
  CapCallPeriod
  CarryPct
  CarryTerms
  CoCommit
  CommodityPool
  CompanyName
  Country
  Custodian
  DealRef
  DissolveDate
  EIN
  ERISAPlan
  EntityType
  ExcessOrgExpAmt
  ExcessOrgExpCap
  FACTAReg
  FFARegNum
  FYEnd
  FinalClose
  FinraCRDNum
  ForeignCounsel
  FundAuditor
  FundFamily
  GIIN
  GP
  GPCommit
  ICAExempt
  InitClose
  InvAmtExclusions
  InvEndDate
  InvExt1
  InvExtProvisions
  InvRestrict
  InvStartDate
  LPCommit
  LargeTraderID
  LoC
  LocAmount
  MFeePct
  MFeeStepDate
  MFeeStepPct
  MFeeStepReason
  MFeeStepStatus
  MFeeStepVerb
  MFeeWaiverProvisions
  MainAddress
  MoneyMktAcctRestrict
  PFFiler
  PartnerEndDate
  PartnerExt1EndDate
  PartnerExt1Pursuant
  PartnerTerm
  PartnerTermExtProvisions
  PlaceAgent
  PreNoticeBorrowList
  PrefReturn
  PrimeBroker
  Purpose
  QualBusIn
  QuickRef
  RegAddress
  RegAgent
  RegDate
  RegNum
  SAClient
  SECFormDFile
  SECFormDNum
  SECPrivFundID
  State
  Status
  TaxProvider
  Tranche1Commit
  Tranche2Commit
  USCounsel
  column_8832ElectClass
  column_8832ElectDate
}
}`)
export default getEntityDB;
